import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { CardStack } from "@shared/models/card-stack"
import type { Group } from "@shared/models/group"
import { objectId } from "@shared/util/object-id"
import FindDoc from "cc-frontend/helpers/find-doc"
import HasManyAltogether from "cc-frontend/helpers/has-many-altogether"
import { insertNewTemplate } from "cc-frontend/lib/actions/course/calendar/COURSE_DATE_SAVE_AS_TEMPLATE"
import { PLANBOOK_CREATE_LESSON_TEMPLATE } from "cc-frontend/lib/actions/planbook/PLANBOOK_CREATE_LESSON_TEMPLATE"
import type Dispatcher from "cc-frontend/services/dispatcher"
import type EmberStore from "cc-frontend/services/ember-store"
import { generateBlankTemplateAttributes } from "cc-frontend/utils/card-stack/blank"
import { use } from "ember-could-get-used-to-this"

interface Signature {
  Args: {
    group: Group
  }
}

export default class SchoolEditTemplates extends Component<Signature> {
  @service("ember-store") declare store: EmberStore
  @service declare dispatcher: Dispatcher

  @use planbook = new FindDoc(() => [
    "planbook",
    this.args.group.attributes.cardStackTemplatesPlanbookId,
  ])

  @use cardStackTemplates = new HasManyAltogether<CardStack>(() => {
    let model = this.planbook.content ? this.planbook.content : null
    return [model, "cardStackTemplates"]
  })

  @action
  addTemplate() {
    if (this.planbook.content === null) return
    let newId = objectId()
    let cardStackAttributes = generateBlankTemplateAttributes(this.planbook.content, "")
    insertNewTemplate(this.store, newId, this.planbook.content.id, cardStackAttributes)
    this.dispatcher.dispatchAction(PLANBOOK_CREATE_LESSON_TEMPLATE, {
      planbookId: this.planbook.content.id,
      cardStackAttributes: cardStackAttributes,
      newId: newId,
      assignTemplatePatches: [],
      assignTemplateUndoPatches: [],
    })
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "School::Edit::Templates": typeof SchoolEditTemplates
  }
}
